import React from 'react';
import PropTypes from 'prop-types';
import Iframe from 'react-iframe';

import '../../../css/storyblok-custom.css';


/**
 * Embed an external URL (e.g. a YouTube embed link).
 *
 * Unlike the 'IFrame' blok, which points at a Storyblok asset and needs a
 * signed URL, this blok holds a plain external URL and is rendered directly.
 */
const IframeEmbed = ({
    url,
    title,
    height,
}) => {

    if (!url || url === "") {
        return null;
    }

    return (
        <div className="storyblok-iframe-embed">
            {title ? <h4 className="subheader">{title}</h4> : null}
            <Iframe url={url} title={title} id={"iframe-embed"} display="flex"
                width="100%" height={height && height !== "" ? height : "400px"}
                allowFullScreen/>
        </div>
    );
};


IframeEmbed.propTypes = {
    /**
     * External URL to embed
     */
    url: PropTypes.string,
    /**
     * Optional title displayed above the frame
     */
    title: PropTypes.string,
    /**
     * Frame height, including units. Defaults to 400px.
     */
    height: PropTypes.string,
};

IframeEmbed.defaultProps = {
    url: "",
    title: "",
    height: "",
};

export default IframeEmbed;
